import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/error'
import { searchPlayFacilities } from '@lib/play-facility-search/search-play-facilities'
import CourseSearchResults from './course-search-results'

/**
 * Flag-off client fetch: Coach Tools geo + direct Algolia (bypasses pga-algolia-service GraphQL).
 * Prefer SSR via getServerSideProps; this covers edge cases where ssrData is absent.
 */
export default function PlayFacilitySearchQuery({ query, ...props }) {
  const [loading, setLoading] = useState(true)
  const [results, setResults] = useState([])
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    setFailed(false)

    const runSearch = async () => {
      try {
        const data = await searchPlayFacilities(query)
        if (cancelled) return
        setResults(Array.isArray(data) ? data : [])
      } catch {
        if (!cancelled) setFailed(true)
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    runSearch()
    return () => { cancelled = true }
  }, [query])

  if (loading) {
    return <LinearProgress color="secondary" />
  }

  if (failed) {
    return <Error statusCode={404} />
  }

  return (
    <CourseSearchResults {...props} query={query} results={results} />
  )
}

PlayFacilitySearchQuery.propTypes = {
  query: PropTypes.object.isRequired,
}
